<template>
    <VCardTitle :class="{ 'cursor-pointer': hasClickEvent }" class="pt-0" @click="$emit('click')">
        <slot name="icon" />
        <span class="sr-app-container-header font-weight-bold brand-blue--text font-default">
            <slot />
        </span>
    </VCardTitle>
</template>

<script>
export default {
    name: 'SrAppContainerHeader',

    computed: {
        hasClickEvent() {
            return !!this.$listeners.click;
        },
    },
};
</script>
